/**
 * RampCX WebRTC Client Configuration (ContinuumCX copy on Hetzner)
 */

const CONFIG = {
  // Application info
  appName: 'RampCX',
  appVersion: '1.0.0',
  
  // Branding
  branding: {
    logoUrl: '/CGS_Full_Logo.svg',
    primaryColor: '#29B5D6',
    secondaryColor: '#3BD162',
  },
  
  // SIP Servers (priority order)
  servers: [
    {
      name: 'Hillsboro (Primary)',
      wsUri: 'wss://hil-kamailio.rampcx.nexuscxm.com:8443/ws',
      sipDomain: 'rampcx.nexuscxm.com',
      priority: 1,
      weight: 100
    },
    {
      name: 'Ashburn (Failover)',
      wsUri: 'wss://ash-kamailio.rampcx.nexuscxm.com:8443/ws',
      sipDomain: 'rampcx.nexuscxm.com',
      priority: 2,
      weight: 50
    }
  ],
  
  // Failover settings
  failover: {
    enabled: true,
    connectTimeout: 5000,      // ms before trying next server
    retryAttempts: 3,          // attempts per server
    probeInterval: 30000,      // ms between primary health checks
    autoFailback: false        // Manual failback only
  },
  
  // Registration
  registration: {
    expires: 300,              // seconds
    refreshBeforeExpiry: 30    // seconds
  },
  
  // Audio settings
  audio: {
    codecs: ['opus/48000/2', 'PCMU/8000', 'PCMA/8000'],
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true
  },
  
  // ICE/NAT traversal
  //
  // We intentionally use NO STUN servers here. Reasons:
  //   1. rtpengine on the Kamailio SBC is our media anchor; it terminates
  //      SRTP/DTLS on the public IP and bridges to plain RTP toward Issabel.
  //      The client only needs to reach rtpengine, not the far end directly.
  //   2. Public STUN (e.g. stun.l.google.com:19302) over UDP is blocked on
  //      many corporate and consumer ISPs. When it's unreachable, ICE
  //      gathering can stall for 30-40s before the INVITE is even sent.
  //   3. With no STUN configured, Chrome immediately produces host candidates
  //      from getUserMedia and trickles them through rtpengine's offer/answer.
  //
  // If we ever need to support agents behind symmetric NAT with no path to
  // rtpengine's public IP, deploy our own TURN server (coturn) and list it in
  // turnServers below.
  ice: {
    stunServers: [],
    turnServers: []
  },
  
  // Agent statuses
  agentStatuses: [
    { id: 'available', label: 'Available', color: '#3BD162', icon: '✓', allowCalls: true },
    { id: 'busy', label: 'Busy', color: '#E53935', icon: '⏺', allowCalls: false, autoSet: true },
    { id: 'acw', label: 'After Call Work', color: '#FFC107', icon: '📝', allowCalls: false },
    { id: 'break', label: 'Break', color: '#FF9800', icon: '☕', allowCalls: false },
    { id: 'meeting', label: 'Meeting', color: '#2196F3', icon: '📅', allowCalls: false },
    { id: 'training', label: 'Training', color: '#9C27B0', icon: '📚', allowCalls: false },
    { id: 'offline', label: 'Offline', color: '#9E9E9E', icon: '○', allowCalls: false }
  ],
  
  // Call settings
  call: {
    autoAnswer: false,
    autoAnswerDelay: 0,        // ms (0 = immediate)
    acwTimeout: 60,            // seconds of ACW after call
    maxHoldTime: 300,          // seconds before warning
    recordingEnabled: false,
    recordingIndicator: true
  },
  
  // Transfer settings
  transfer: {
    blindTransferEnabled: true,
    attendedTransferEnabled: true,
    warmTransferHoldMusic: true,
    transferTimeout: 30        // seconds before transfer fails
  },
  
  // Conference settings
  conference: {
    enabled: true,
    maxParticipants: 3,        // Including agent
    conferenceNumber: '*98'    // Dial this to bridge
  },
  
  // Media Helper (VDI support)
  mediaHelper: {
    enabled: false,            // Enable for VDI environments
    autoConnect: true,
    wsPort: 9876,
    fallbackToVdi: true,       // Use VDI audio if helper unavailable
    reconnectInterval: 5000,
    heartbeatInterval: 10000
  },
  
  // Keyboard shortcuts
  shortcuts: {
    answer: 'Enter',
    hangup: 'Escape',
    mute: 'M',
    hold: 'H',
    transfer: 'T',
    dialpad: 'D'
  },
  
  // Notifications
  notifications: {
    desktop: true,
    sound: true,
    tabFlash: true,
    ringtone: '/sounds/ringtone.mp3',
    volume: 0.7
  },
  
  // Omnichannel channels (for future)
  channels: {
    voice: { enabled: true, icon: '📞', label: 'Voice' },
    chat: { enabled: false, icon: '💬', label: 'Chat' },
    email: { enabled: false, icon: '📧', label: 'Email' },
    sms: { enabled: false, icon: '📱', label: 'SMS' }
  },
  
  // Feature flags
  features: {
    callHistory: true,
    voicemail: false,
    screenPop: false,
    crmIntegration: false,
    qualityMetrics: true,
    speedDial: true
  }
};

export default CONFIG;
